import * as actionTypes from './actionTypes';

import { sendNotification } from "../../push-notifications";

export const getNotifications = (data) => {
    return {
        type: actionTypes.GET_NOTIFICATIONS,
        data: data
    };
};

export const addNotificationAction = (data) => {
    if (data.push) {
        sendNotification(data.title || "BS Portaal boodskap", data.message || "Jy het 'n boodskap op die boerdery stelsel portaal");
    }
    return {
        type: actionTypes.ADD_NOTIFICATION,
        data: data
    };
};

export const setNotifications = (data) => {
    for (const boodskap of data) {
        if (boodskap.push && !boodskap.viewed) {
            sendNotification(boodskap.title || "BS Portaal boodskap", boodskap.message || "Jy het 'n boodskap op die boerdery stelsel portaal");
        }
    }
    return {
        type: actionTypes.SET_NOTIFICATIONS,
        data: data
    };
};

export const getNotificationsFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_NOTIFICATIONS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const removeNotification = (id) => {
    return {
        type: actionTypes.REMOVE_NOTIFICATION,
        id: id
    };
};